import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';
import { useId } from 'react';

const Bottomhole = props => {
    const { research, scale, minDepth, width, date, title, toDepth } = props;

    const { isInflow, fluid_type } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const clipId0 = useId();
    const clipId1 = useId();

    const minHeight = 30;
    const minWidth = 75;
    const actualWidth = Math.max(minWidth, width);

    if (isInflow) {
        return (
            <Tooltip
                styles={{ root: { maxWidth: 'none' } }}
                title={
                    <FiguresTooltip
                        title={title}
                        roof={roof}
                        bottom={bottom}
                        date={date}
                        inFlow={isInflow}
                        fluid={fluid_type}
                    />
                }
            >
                <svg
                    data-bottomhole-title={`${title}`}
                    width={actualWidth}
                    height={minHeight}
                    viewBox="0 0 199 40"
                    preserveAspectRatio="xMidYMid slice"
                    overflow="hidden"
                    fill="none"
                    style={{
                        position: 'absolute',
                        left: '50%',
                        transform: `translate(-50%, ${Math.abs((minDepth - roof) * scale)}px)`,
                        width: actualWidth
                    }}
                >
                    <g clipPath={`url(#${clipId0})`}>
                        <path
                            d="M99 0L96.1133 5L101.887 5L99 0ZM98.5 4.5L98.5 40L99.5 40L99.5 4.5L98.5 4.5Z"
                            fill="#7E8DA9"
                        />
                        <path d="M200 22L8.0947e-08 22L-8.0947e-08 21L200 21L200 22Z" fill="#7E8DA9" />
                        <g clipPath={`url(#${clipId1})`}>
                            <path
                                d="M192.818 26.9746L198.475 21.3177L199.182 22.0248L193.525 27.6817L192.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M180.818 26.9746L186.475 21.3177L187.182 22.0248L181.525 27.6817L180.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M168.818 26.9746L174.475 21.3177L175.182 22.0248L169.525 27.6817L168.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M156.818 26.9746L162.475 21.3177L163.182 22.0248L157.525 27.6817L156.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M144.818 26.9746L150.475 21.3177L151.182 22.0248L145.525 27.6817L144.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M132.818 26.9746L138.475 21.3177L139.182 22.0248L133.525 27.6817L132.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M120.818 26.9746L126.475 21.3177L127.182 22.0248L121.525 27.6817L120.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M108.818 26.9746L114.475 21.3177L115.182 22.0248L109.525 27.6817L108.818 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M84.8183 26.9746L90.4752 21.3177L91.1823 22.0248L85.5254 27.6817L84.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M72.8183 26.9746L78.4752 21.3177L79.1823 22.0248L73.5254 27.6817L72.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M60.8183 26.9746L66.4752 21.3177L67.1823 22.0248L61.5254 27.6817L60.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M48.8183 26.9746L54.4752 21.3177L55.1823 22.0248L49.5254 27.6817L48.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M36.8183 26.9746L42.4752 21.3177L43.1823 22.0248L37.5254 27.6817L36.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M24.8183 26.9746L30.4752 21.3177L31.1823 22.0248L25.5254 27.6817L24.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M12.8183 26.9746L18.4752 21.3177L19.1823 22.0248L13.5254 27.6817L12.8183 26.9746Z"
                                fill="#7E8DA9"
                            />
                            <path
                                d="M0.818322 26.9746L6.47518 21.3177L7.18228 22.0248L1.52543 27.6817L0.818322 26.9746Z"
                                fill="#7E8DA9"
                            />
                        </g>
                    </g>
                    <defs>
                        <clipPath id={clipId0}>
                            <rect width="199" height="40" fill="white" />
                        </clipPath>
                        <clipPath id={clipId1}>
                            <rect width="100%" height="100%" fill="white" transform="translate(0 21.5)" />
                        </clipPath>
                    </defs>
                </svg>
            </Tooltip>
        );
    }

    return (
        <Tooltip
            styles={{ minWidth: 'fit-content' }}
            title={
                <FiguresTooltip
                    title={title}
                    roof={roof}
                    bottom={bottom}
                    date={date}
                    inFlow={isInflow}
                    fluid={fluid_type}
                />
            }
        >
            <svg
                data-bottomhole-title={title}
                width={actualWidth}
                height={minHeight}
                viewBox="0 0 199 40"
                preserveAspectRatio="xMidYMid slice"
                overflow="hidden"
                fill="none"
                style={{
                    position: 'absolute',
                    left: '50%',
                    transform: `translate(-50%, ${Math.abs((minDepth - roof - 1) * scale)}px)`,
                    width: actualWidth
                }}
            >
                <g clipPath={`url(#${clipId0})`}>
                    <path
                        d="M99 40L96.1133 35L101.887 35L99 40ZM98.5 35.5L98.5 5.90104e-09L99.5 -5.90104e-09L99.5 35.5L98.5 35.5Z"
                        fill="#7E8DA9"
                    />
                    <path d="M200 17L8.0947e-08 17L-8.0947e-08 18L200 18L200 17Z" fill="#7E8DA9" />
                    <g clipPath={`url(#${clipId1})`}>
                        <path
                            d="M7.18168 18.0254L1.52482 23.6823L0.817717 22.9752L6.47457 17.3183L7.18168 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M19.1817 18.0254L13.5248 23.6823L12.8177 22.9752L18.4746 17.3183L19.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M31.1817 18.0254L25.5248 23.6823L24.8177 22.9752L30.4746 17.3183L31.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M43.1817 18.0254L37.5248 23.6823L36.8177 22.9752L42.4746 17.3183L43.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M55.1817 18.0254L49.5248 23.6823L48.8177 22.9752L54.4746 17.3183L55.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M67.1817 18.0254L61.5248 23.6823L60.8177 22.9752L66.4746 17.3183L67.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M79.1817 18.0254L73.5248 23.6823L72.8177 22.9752L78.4746 17.3183L79.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M91.1817 18.0254L85.5248 23.6823L84.8177 22.9752L90.4746 17.3183L91.1817 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M115.182 18.0254L109.525 23.6823L108.818 22.9752L114.475 17.3183L115.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M127.182 18.0254L121.525 23.6823L120.818 22.9752L126.475 17.3183L127.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M139.182 18.0254L133.525 23.6823L132.818 22.9752L138.475 17.3183L139.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M151.182 18.0254L145.525 23.6823L144.818 22.9752L150.475 17.3183L151.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M163.182 18.0254L157.525 23.6823L156.818 22.9752L162.475 17.3183L163.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M175.182 18.0254L169.525 23.6823L168.818 22.9752L174.475 17.3183L175.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M187.182 18.0254L181.525 23.6823L180.818 22.9752L186.475 17.3183L187.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                        <path
                            d="M199.182 18.0254L193.525 23.6823L192.818 22.9752L198.475 17.3183L199.182 18.0254Z"
                            fill="#7E8DA9"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id={clipId0}>
                        <rect width="199" height="40" fill="white" transform="matrix(1 0 0 -1 0 40)" />
                    </clipPath>
                    <clipPath id={clipId1}>
                        <rect width="100%" height="100%" fill="white" transform="translate(200 23.5) rotate(-180)" />
                    </clipPath>
                </defs>
            </svg>
        </Tooltip>
    );
};

export default Bottomhole;
